import React from 'react';
import { useAuth } from '../context/AuthContext.js'; // 1. Import useAuth
import { useNavigate } from 'react-router-dom';
import './AdminSidebar.css';
import logo from '../assests/logo-dark.png';

// --- Icon Components ---
const IconHome = () => ( <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"> <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><polyline points="9 22 9 12 15 12 15 22" /> </svg> );
const IconUsers = () => ( <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"> <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /> </svg> );
const IconPackage = () => ( <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"> <line x1="16.5" y1="9.4" x2="7.5" y2="4.21" /><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" /><polyline points="3.27 6.96 12 12.01 20.73 6.96" /><line x1="12" y1="22.08" x2="12" y2="12" /> </svg> );
const IconLogout = () => ( <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"> <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><polyline points="16 17 21 12 16 7" /><line x1="21" y1="12" x2="9" y2="12" /> </svg> );
const IconKitchen = () => ( <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"> <path d="M20 10.5c0-.28-.03-.55-.08-.83a1 1 0 0 0-.42-.62l-2.06-1.37a2 2 0 0 1-1-1.7V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2a2 2 0 0 1-1 1.7L5.5 8.05a1 1 0 0 0-.42-.62c-.05.28-.08.55-.08.83V12a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-1.5z"></path><path d="M5 13v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6"></path> </svg> );
// --- End of Icon Components ---

function AdminSidebar({ activeTab, setActiveTab }) {
  const navigate = useNavigate();
  const { logout } = useAuth(); // 2. Get the logout function from our context

  const handleLogout = () => {
    logout(); // 3. Call the context logout
    navigate('/'); 
  };

  return (
    <aside className="admin-sidebar">
      <div className="sidebar-logo-container">
        <img src={logo} alt="Degchi Logo" className="sidebar-logo-img" />
       
      </div>
      <nav className="sidebar-nav">
        <button onClick={() => setActiveTab('dashboard')} className={`nav-button ${activeTab === 'dashboard' ? 'active' : ''}`} > <IconHome /> <span>Dashboard</span> </button>
        <button onClick={() => setActiveTab('subscribers')} className={`nav-button ${activeTab === 'subscribers' ? 'active' : ''}`} > <IconUsers /> <span>Subscribers</span> </button>
        <button onClick={() => setActiveTab('kitchen')} className={`nav-button ${activeTab === 'kitchen' ? 'active' : ''}`} > <IconKitchen /> <span>Kitchen Prep</span> </button>
        <button onClick={() => setActiveTab('inventory')} className={`nav-button ${activeTab === 'inventory' ? 'active' : ''}`} > <IconPackage /> <span>Inventory</span> </button>
      </nav>
      <div className="sidebar-footer">
        <button onClick={handleLogout} className="nav-button logout-button">
          <IconLogout />
          <span>Logout</span>
        </button>
      </div>
    </aside>
  );
}

export default AdminSidebar;

